<template>
  <div class="all_discuss_main">
    <div class="all_discuss_list">
      <div class="discuss_list_wrap">
        <ul v-if="discussList && discussList.length>0">
          <li class="lis" v-for="(item,key) in discussList" :key="key" @click="jumpDetails(item)">
            <div class="head_portrait">
              <img v-if="item.userType==0" :src="teacherHead"/>
              <img v-else-if="item.userType==1" :src="teacherHead"/>
              <img v-else-if="item.userType==2" :src="item.anonymous==0?anonymousHead:studentHead"/>
              <img v-else :src="anonymousHead"/>
            </div>
            <div class="list_info">
              <div class="list_info_line">
                <div class="list_info_line_box">
                  <span class="user_name">{{item.anonymous==0?'匿名用户':item.userName}}</span>
                </div>
                <div class="list_info_line_box">
                  <span class="user_type" v-if="item.userType==0||item.userType==1">教师</span>
                </div>
                <div class="list_info_line_box">
                  <span class="time">{{item.createTimeStr}}</span>
                </div>
                <div class="list_info_line_box">
                  <span class="status" v-if="item.repliedOrParticipation">{{item.repliedOrParticipationName}}</span>
                </div>
              </div>
              <div class="list_info_line">
                <p>{{item.theme}}</p>
              </div>
              <div class="list_info_line">
                <div class="chapter" v-if="item.catalogId!=''&&item.discussionAreaId!=3">
                  <img src="../../../../../../../static/images/study/icon/zhangjie.png"/>
                  <span>{{item.catalogId!=null?item.catalogName:'全部教学章节'}}</span>
                </div>
                <div class="operation">
                  <ol>
                    <li><img src="../../../../../../../static/images/study/icon/chakan_hv.png" alt=""><span>{{(item.viewCount&&item.viewCount!=null)?item.viewCount:0}}</span></li>
                    <li><img src="../../../../../../../static/images/study/icon/dianzan_hv.png" alt=""><span>{{(item.praiseCount&&item.praiseCount!=null)?item.praiseCount:0}}</span></li>
                    <li><img src="../../../../../../../static/images/study/icon/pinglun_hv.png" alt=""><span>{{(item.replyCount&&item.replyCount!=null)?item.replyCount:0}}</span></li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="respective_region">
              <span>【{{item.discussionAreaName}}】</span>
            </div>
            <div class="is_top" v-if="item.roofPlacement">
              <img src="../../../../../../../static/images/study/icon/zhiding.png"/>
            </div>
          </li>
        </ul>
        <div class="no_discuss_list" v-else>
          <img src="../../../../../../../static/images/wujieguo.png"/>
          <p>暂无相关内容</p>
        </div>
      </div>
      <div class="discuss_pagination">
        <pagination
	        :currentpage="pageTotal.currentPage"
	        :limit="pageTotal.pageSize"
	        :total="pageTotal.total"
	        layout="sizes, prev, pager, next, jumper"
	        @handleCurrentChange="handleCurrentChange"
	        @handleSizeChange="handleSizeChange"
	        :small="true"
	        v-if="pageTotal.total>10"
	      ></pagination>
      </div>
    </div>
    
  </div>
</template>
<script>
import Pagination from '../../../../../paginator/paginator.vue';
import * as api from "../../../../../../api/discussApi";
export default {
  name: 'discussList',
  components: {
    Pagination
  },
  props: {
    discussList: {
      type: Array,
      default: () => []
    },
    region: {
      type: String,
      default: ''
    },
    pageTotal: {
      type: Object,
      default: ()=>{}
    }
  },
  watch:{
    pageTotal(val){
      // console.log(val)
    },
  },
  data() {
    return {
      teacherHead:'../../../../../../../static/images/study/icon/teacher.png',
      studentHead:'../../../../../../../static/images/study/icon/student.png',
      anonymousHead:'../../../../../../../static/images/study/icon/niming.png',
      ownValue: false,
      teacherPartake: false,
      teacherAnswered: false,
      selectedChapterValue: '', // 所属章节
      selectedChapterOpt: [],
      userType: sessionStorage.getItem('userType')
    }
  },
  mounted() {
    if(this.region=='teacher'){
      this.getChapter()
    }
  },
  methods: {
    jumpDetails(item){
      let obj = {
        router: '主题详情',
        region: this.region,
        item: item
      }
      this.$emit('jumpDetails', obj);
    },
    currentPageFn(val){
      this.$emit('currentPageFn',val)
    },
    getChapter(){
      let that = this;
      api.getChapter(that.$route.query.id).then(rs=>{
        if(rs.code==0){
          let allChapter = {
            catalogContext: null,
            catalogName: "全部教学章节",
            catalogParentId: 0,
            catalogSort: 0,
            children: undefined,
            courseId: 654,
            id: 0,
            isFinish: 0,
            parentFlag: 0,
            schoolId: null,
            taskType: 0,
          }
          that.getTreeList(rs.data)
          // that.selectedChapterOpt.unshift(allChapter)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getTreeList(data){
      for(var i=0;i<data.length;i++){
        this.selectedChapterOpt.push(data[i])
        if(data[i].children.length<1){
          data[i].children=undefined;
        }else {
          this.getTreeList(data[i].children);
        }
      }
      return data;
    },
    searchChapter(val){
      this.$emit('searchChapter', val);
    }
  },
}
</script>
<style lang="scss">
  .all_discuss_main{
    height: calc(100% - 50px);
    .all_discuss_list{
      height: calc(100% - 40px);
      .discuss_list_tab{
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        box-sizing: border-box;
        ul{
          display: flex;
          li{
            position: relative;
            border-right: 1px solid #E6E6E6;
            text-align: center;
            line-height: 12px;
            cursor: pointer;
            &:last-child{
              border: none;
            }
            span{
              margin: 0 13px;
              padding: 5px 17px;
              color: #999999;
            }
          }
          .active{
            span{
              background:rgba(83,151,247,1);
              border-radius:16px;
              color: #fff;
            }
          }
        }
        .search_chapter{
          margin-left: 10px;
          .el-input__inner{
            height: 32px;
            line-height: 32px;
          }
          .el-input__icon{
            line-height: 32px;
          }
        }
        .switch_wrap{
          .el-switch{
            margin-left: 10px;
            .el-switch__core{
              border-radius: 4px;
              &::after{
                left: 6%;
                top: 2px;
                height: 13px;
                border-radius: 3px;
                background: #999;
              }
            }
            .el-switch__label.el-switch__label--right{
              color: #999999;
            }
            .el-switch__label.el-switch__label--right.is-active{
              color: #5397F7;
            }
          }
          .el-switch.is-checked{
            .el-switch__core{
              &::after{
                left: 90%;
                background: #fff;
              }
            }
          }
        }
      }
      .discuss_list_wrap{
      	height: 100%;
        overflow-y: auto;
        ul{
          padding: 0 24px;
          padding-right: 5px;
          box-sizing: border-box;
          .lis{
            width: 100%;
            height:104px;
            background: #F6F8FB;
            border:1px solid #F6F8FB;
            border-radius:4px;
            margin-bottom: 16px;
            padding-left: 73px;
            box-sizing: border-box;
            position: relative;
            cursor: pointer;
            &:hover{
              box-shadow:0px 3px 12px rgba(83,151,247,0.67);
            }
            .head_portrait{
              position: absolute;
              left: 24px;
              top: 8px;
              img{
                width: 40px;
              }
            }
            .list_info{
              width: 100%;
              margin-top: 12px;
              .list_info_line{
                width: 100%;
                &:nth-child(1){
                  margin-bottom: 8px;
                  .user_name{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                  }
                  .user_type{
                    line-height:18px;
                    background:#B4BBCD;
                    border-radius:8px;
                    padding: 0 8px;
                    margin-left: 8px;
                    font-size:12px;
                    font-weight:400;
                    color:#fff;
                  }
                  .time{
                    font-size:12px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    margin: 0 40px;
                  }
                  .status{
                    line-height:18px;
                    border:1px solid rgba(83,151,247,1);
                    border-radius:2px;
                    padding: 0 6px;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(83,151,247,1); 
                  }
                }
                &:nth-child(2){
                  p{
                    max-width: 900px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                &:nth-child(3){
                  margin-top:20px;
                  .chapter{
                    float: left;
                    display: flex;
                    align-items: center;
                    img{
                      width: 14px;
                    }
                    span{
                      font-size:12px;
                      font-weight:400;
                      color:rgba(153,153,153,1);
                      margin-left: 4px;
                    }
                  }
                  .operation{
                    float: right;
                    ol{
                      display: flex;
                      li{
                        width: 80px;
                        text-align: center;
                        border-right:1px solid #E6E6E6;
                        line-height: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:last-child{
                          border-right: none;
                        }
                        img{
                          width: 14px;
                        }
                        span{
                          font-size:12px;
                          font-weight:400;
                          color:rgba(153,153,153,1);
                          margin-left: 6px;
                        }
                      }
                    }
                  }
                }
                .list_info_line_box{
                  display: inline-block;
                }
              }
            }
            .respective_region{
              position: absolute;
              right: 14px;
              top: 16px;
              span{
                font-size:14px;
                font-weight:400;
                color:rgba(83,151,247,1);
              }
            }
            .is_top{
              position: absolute;
              left: 0;
              top: 0;
              img{
                width: 60px;
              }
            }
          }
        }
      }
      .discuss_pagination{
        height: 55px;
        padding: 0 24px;
      }
    }
    .no_discuss_list{
      height: calc(100% - 40px);
      text-align: center;
      img{
        width: 200px;
        margin-top: 100px;
      }
      p{
        font-size:14px;
        font-weight:400;
        color:rgba(153,153,153,1);
        margin-top: 16px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/discuss/component/discussList.vue